'use strict';

var domPrefixes = 'Webkit Moz O ms Khtml'.split(' ');

export function toCamelCase(cssProp) {
  return cssProp.replace(/-([a-z])/gi, function(s, prop) {
    return prop.toUpperCase();
  });
}

function isStyleSupported(property) {
  var result = false;
  var el = document.body ? document.body : document.createElement('div');

  // Is property supported without a prefix
  if (el.style[toCamelCase(property)] !== undefined) {
    result = true;
  } else {
    property = toCamelCase('-' + property);
    for (let i = 0; i < domPrefixes.length; i++) {
      //check with dom prefixes
      if (el.style[domPrefixes[i] + property] !== undefined) {
        result = true; //supported with dom prefix
        break;
      }
    }
  }

  return result;
}

function areAllStylesSupported(properties) {
  return properties.every(property => isStyleSupported(property));
}

function areSomeStylesSupported(properties) {
  return properties.some(property => isStyleSupported(property));
}

export { isStyleSupported, areAllStylesSupported, areSomeStylesSupported };
